import React from "react";
import { string, number } from "prop-types";

/* Plus icon atom component for team card expand button */
const PlusIcon = ({ color = "#FFFFFF", size = 12, strokeWidth = 2 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 12 12" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M6 0V12M0 6H12" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
  </svg>
);

PlusIcon.propTypes = {
  color: string,
  size: number
};

export default PlusIcon;

